import React from 'react';

const NotificationToast = ({ notification }) => {
    if (!notification) {
        return null;
    }

    return (
        <div
            className={`fixed top-4 right-4 p-3 rounded-lg shadow-md text-white text-sm ${
                notification.type === 'success'
                    ? 'bg-green-500'
                    : notification.type === 'info'
                        ? 'bg-blue-500'
                        : 'bg-red-500'
            }`}
        >
            {notification.message}
        </div>
    );
};

export default NotificationToast;
